import { swiffyslider } from 'swiffy-slider'
import { queryAll, query } from '../utils/utils.js';
import "swiffy-slider/css"
window.swiffyslider = swiffyslider;

const viewAll = () => {
	//view all uses native bootstrap to hide show. Here we hide the view all after all are shown.
	const viewAllButtons = queryAll('.view-all-btn');
	viewAllButtons.forEach((btn , i) => {
		btn.addEventListener('click', (event) => {
			btn.classList.add('d-none');
			const awardsBlock = btn.closest('.awards-block');
			if (awardsBlock) {
				awardsBlock.classList.add('is-expanded');
			}
		});
	});
};


export { viewAll };
